import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';

import { RefreshRequiredModalComponent } from './refresh-required-modal.component';

@NgModule({
    imports: [CommonModule, ModalBaseModule],
    declarations: [RefreshRequiredModalComponent],
    exports: [RefreshRequiredModalComponent],
})
export class RefreshRequiredModalModule {}
